module.exports = __webpack_public_path__ + "img/C.7f7330f1.svg";